<template>
  <div>
    <h3 class="modal-title"> TIMESHEET APPROVAL </h3>
    <b-form-group :class="{'error-input' : $v.data_timesheet.title.$error}">
      <label> Timesheet Approval Title </label>
      <j-input
        v-model="$v.data_timesheet.title.$model"
        :max-length="255"
        placeholder="Title"/>
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeTimesheet">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveTimesheet">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_timesheet: {
      title: {
        required,
      },
      // timesheet: {
      //   required,
      // },
    },
  },
  data() {
    return {
      data_timesheet: {
        title: '',
        // timesheet: null,
      },
    };
  },
  computed: {
    generateDataTimesheet() {
      const data = {
        // value_id: `${this.data_timesheet.timesheet.id}`,
        value_id: '0',
        pages_id: `${this.dataMaster.pages_id}`,
        name: this.data_timesheet.title,
        component_master_id: this.dataMaster.id,
        info: '',
      };
      return data;
    },

    generateDataTimesheetUpdate() {
      const data = {
        // value_id: `${this.data_timesheet.timesheet.id}`,
        value_id: '0',
        pages_id: `${this.dataEdit.pages_id}`,
        name: this.data_timesheet.title,
        order: this.dataEdit.order,
        component_master_id: this.dataMaster.id,
        info: '',
      };
      return data;
    },
  },
  mounted() {
    if (this.modeEdit) {
      // this.data_timesheet.timesheet = {
      //   id: JSON.parse(this.dataEdit.info).id,
      //   name: JSON.parse(this.dataEdit.info).name,
      // };
      this.data_timesheet.title = this.dataEdit.name;
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveComponent', 'updateComponent']),

    saveTimesheet() {
      this.$v.data_timesheet.$touch();
      if (!this.$v.data_timesheet.$error) {
        if (!this.modeEdit) {
          const dataParam = {
            data: this.generateDataTimesheet,
            id: this.dataMaster.id,
          };
          this.saveComponent(dataParam);
        } else {
          const dataParam = {
            data: this.generateDataTimesheetUpdate,
            id: this.dataMaster.id,
            component_id: this.dataEdit.id,
          };
          this.updateComponent(dataParam);
        }

        this.closeTimesheet();
      }
    },

    closeTimesheet() {
      this.$emit('close-field');
      this.data_timesheet.title = '';
      // this.data_timesheet.timesheet = null;
      setTimeout(() => {
        this.$v.data_timesheet.$reset();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/pages-component/times/jTimesheetApprovalSetup.vue